import { ModelBase } from '../../core/model/model-base';
import { RentalObjectCategory, TenantCategory, RentalObjectCategoryToString } from './const/enums';
import { LocalDate } from '../../core/model/local-date';
import { Contact, ContactIdKind } from './contact';

export class RentApplication extends ModelBase {
  constructor() {
    super();
    this.applicationDate = LocalDate.today();
    this.rentalObjectCategory = RentalObjectCategory.Dwelling;
    this.contactCategory = TenantCategory.PhysicalPerson;
    this.idType = ContactIdKind.None;
  }

  public set applicationDate(value: LocalDate) {
    this._applicationDate = LocalDate.fromDate(value);
  }
  public get applicationDate(): LocalDate {
    return this._applicationDate;
  }

  private _applicationDate: LocalDate;
  public rentalObjectCategory: RentalObjectCategory;
  public comment: string;
  public contactId: string;
  public contactIdExistingContact: string;
  public contactEmail: string;
  public contactPhone: string;
  public contactCategory: TenantCategory;
  public contactCustomerNumber: number;
  public contactName: string;
  public contactIdentification: string;
  public idType: ContactIdKind;
  public maxYearRent: number;
  public numberOfRoomsMax: number;
  public numberOfRoomsMin: number;

  get rentalObjectCategoryCaption(): string {
    return RentalObjectCategoryToString(this.rentalObjectCategory);
  }

  get firstPartOfNote(): string {
    if (!this.comment || this.comment.length <= 33) return this.comment;
    return this.comment.substr(0, 30) + '...';
  }

  toJSON() {
    let json = Object.assign({}, this);
    json.applicationDate = this.applicationDate;
    return json;
  }

  toString() {
    return `${this.contactName}`;
  }
}
